import React from "react";

function AdminInfo({ header, value }) {
  const valueDecision = () => {
    if (value === true) {
      return (
        <div className="admin-header-info-value-true">
          <span>True</span>
        </div>
      );
    } else if (value === false) {
      return (
        <div className="admin-header-info-value-false">
          <span>False</span>
        </div>
      );
    } else {
      return <div className="admin-header-info-value">{value}</div>;
    }
  };
  return (
    <div className="admin-info-components">
      <div className="row">
        <div className="col-md-4">
          <h5 className="admin-header-info">{header}</h5>
        </div>
        <div className="col-md-4">{valueDecision()}</div>
        <div className="col-md-4"></div>
      </div>
    </div>
  );
}

export default AdminInfo;
